import { module as BaseModule } from 'modujs'
import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { body } from '../utils/environment'

gsap.registerPlugin(SplitText)

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.title = this.$('title')[0]
    this.text = this.$('text')
    this.line = this.$('line')[0]
    this.imageWrapper = this.$('image-wrapper')[0]
    this.image = this.$('image')[0]

    this.splitParent = new SplitText(this.title, { type: 'lines', linesClass: 'parent-line', tag: 'span' })
    this.splitChild = new SplitText(this.title, { type: 'lines', tag: 'span' })
  }

  init() {
    gsap.set(this.line, { scaleX: 0, transformOrigin: 'left' })
    gsap.set(this.splitChild.lines, { overflow: 'hidden' })
    gsap.set(this.splitParent.lines, { yPercent: 100 })
    gsap.set(this.text, { autoAlpha: 0 })
    gsap.set(this.imageWrapper, { transformOrigin: 'top', clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)' })
    gsap.set(this.image, { scale: 1.3 })

    setTimeout(() => {
      if (body.classList.contains('template-contact')) {
        this.contact()
      } else {
        this.default()
      }
    }, 10)
  }

  default() {
    // console.log('default')
    const tl = gsap.timeline()

    tl.to(this.splitParent.lines, {
      delay: 0.5,
      yPercent: 0,
      duration: 0.6,
      stagger: window.matchMedia('(min-width:600px)').matches ? 0.2 : 0.1,
      ease: 'power2.out',
    })
      .to(this.line, {
        scaleX: 1,
        duration: 1.7,
        ease: 'expo.inOut',

      }, '-=1.2')
      .to(this.imageWrapper, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.7,
        ease: 'expo.inOut',
      }, '-=1.5')
      .to(this.image, {
        scale: 1,
        duration: 1.7,
        ease: 'power3.inOut',
      }, '-=1.7')
  }

  contact() {
    // console.log('contact')
    const tl = gsap.timeline()

    tl.to(this.splitParent.lines, {
      delay: 0.5,
      yPercent: 0,
      duration: 0.6,
      stagger: window.matchMedia('(min-width:600px)').matches ? 0.2 : 0.1,
      ease: 'power2.out',
    })
      .to(this.line, {
        scaleX: 1,
        duration: 1.7,
        ease: 'expo.inOut',

      }, '-=1.2')
      .to(this.imageWrapper, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.7,
        ease: 'expo.inOut',
      }, '-=1.5')
      .to(this.image, {
        scale: 1,
        duration: 1.7,
        ease: 'power3.inOut',
      }, '-=1.7')
      .to(this.text, {
        autoAlpha: 1,
        duration: 0.6,
        stagger: 0.2,
      }, '-=0.8')
  }
}
